import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { Logo } from "@/components/Logo";

const links = [
    { id: "photo-estimator", label: "AI Estimator" },
    { id: "services", label: "Services" },
    { id: "quote", label: "Full Quote" },
    { id: "faq", label: "FAQ" },
];

export default function Header() {
    const [scrolled, setScrolled] = useState(false);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 80);
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    const scrollTo = (id) => {
        setOpen(false);
        document
            .getElementById(id)
            ?.scrollIntoView({ behavior: "smooth", block: "start" });
    };

    return (
        <header
            data-testid="site-header"
            className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
                scrolled
                    ? "backdrop-blur-xl bg-carbon/85 border-b border-white/10"
                    : "bg-transparent"
            }`}
        >
            <div className="max-w-7xl mx-auto px-6 md:px-10 h-20 flex items-center justify-between">
                <a
                    href="/"
                    data-testid="brand-logo"
                    className="flex items-center group"
                >
                    <Logo light />
                </a>

                <nav className="hidden md:flex items-center gap-9">
                    {links.map((l) => (
                        <button
                            key={l.id}
                            data-testid={`nav-${l.id}`}
                            onClick={() => scrollTo(l.id)}
                            className="text-sm font-medium tracking-wide transition-colors text-slate-300 hover:text-electric"
                        >
                            {l.label}
                        </button>
                    ))}
                </nav>

                <div className="hidden md:flex items-center gap-4 ml-10">
                    <a
                        href="/shops"
                        data-testid="nav-join-repairer"
                        className="px-5 py-2.5 text-sm font-bold text-carbon bg-electric hover:brightness-110 transition-all hover:-translate-y-0.5 active:scale-95 shadow-glow-cyan rounded-2xl"
                    >
                        Join as a Repairer
                    </a>
                    <button
                        data-testid="header-cta-quote"
                        onClick={() => scrollTo("photo-estimator")}
                        className="px-5 py-2.5 text-sm font-bold text-white bg-safety hover:bg-safety-dark transition-all hover:-translate-y-0.5 active:scale-95 shadow-glow-orange rounded-2xl"
                    >
                        Get Instant Quote
                    </button>
                </div>

                <button
                    onClick={() => setOpen((v) => !v)}
                    className="md:hidden text-white"
                    data-testid="mobile-menu-toggle"
                    aria-label="Toggle menu"
                >
                    {open ? <X size={22} /> : <Menu size={22} />}
                </button>
            </div>

            {open && (
                <div className="md:hidden border-t border-white/10 bg-carbon/95 backdrop-blur-xl">
                    <div className="px-6 py-6 flex flex-col gap-5">
                        {links.map((l) => (
                            <button
                                key={l.id}
                                onClick={() => scrollTo(l.id)}
                                data-testid={`mobile-nav-${l.id}`}
                                className="text-left text-slate-300 hover:text-electric"
                            >
                                {l.label}
                            </button>
                        ))}
                        <a
                            href="/shops"
                            data-testid="mobile-nav-join-repairer"
                            className="mt-2 px-5 py-3 text-sm font-bold text-carbon bg-electric rounded-2xl text-center"
                        >
                            Join as a Repairer
                        </a>
                        <button
                            data-testid="mobile-cta-quote"
                            onClick={() => scrollTo("photo-estimator")}
                            className="px-5 py-3 text-sm font-bold text-white bg-safety rounded-2xl"
                        >
                            Get Instant Quote
                        </button>
                    </div>
                </div>
            )}
        </header>
    );
}
